import React from 'react'
import { Grid } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
import messages from '../../../messages'
import { FormattedMessage } from 'react-intl'
import { configContext } from '../../../utils/StandardReducer'
import { TubeProperties } from '../enum'

const useStyles = makeStyles((theme: Theme) => {
  return {
    contentWrapper: {
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(2, 5, 4),
      marginBottom: theme.spacing(5),
    },
    subHead: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightBold,
      margin: theme.spacing(2, 0),
    },
    label: {
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(14),
      marginBottom: theme.spacing(1),
    },
    subLabel: {
      fontSize: theme.typography.pxToRem(14),
      marginBottom: theme.spacing(2),
    },
    specificationsWrapper: {
      '& span.MuiFormControlLabel-label': {
        fontSize: theme.typography.pxToRem(14),
      },
    },
    radio: {
      padding: theme.spacing(1),
    },
    fieldLabel: {
      marginTop: theme.spacing(5),
      '& label': {
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14),
      },
      '& .MuiInput-root': {
        width: '75%',
        '& .MuiSelect-root': {
          height: 35,
          lineHeight: '25px',
        },
      },
    },
    gridItem: {
      marginBottom: theme.spacing(2),
    },
  }
})

const AquaSpecifications = (props) => {
  const classes = useStyles()
  const { specificationsData } = props
  const { productDetails } = props
  const { state } = React.useContext(configContext)
  const { sessionData, currentOligoIndex } = state
  const [amount, setAmount] = React.useState<any>(
    sessionData[state.currentOligoIndex].amount
  )
  const [purityLevel, setPurityLevel] = React.useState<any>(
    sessionData[state.currentOligoIndex].purityLevel
  )
  const [quantitation, setQuantitation] = React.useState<any>(
    sessionData[state.currentOligoIndex].quantitation
  )
  const [format, setFormat] = React.useState<any>(
    sessionData[state.currentOligoIndex].format
  )

  const defaultSelect = (specificationsData) => {
    return specificationsData.specifications.map((specification) => {
      if (specification.categoryName === TubeProperties.Amount) {
        setAmount(specification.specificationModifications[0].value)
      } else if (specification.categoryName === TubeProperties.PurityLevel) {
        setPurityLevel(specification.specificationModifications[0].value)
      } else if (specification.categoryName === TubeProperties.Quantitation) {
        setQuantitation(specification.specificationModifications[0].value)
      } else if (specification.categoryName === TubeProperties.Format) {
        setFormat(specification.specificationModifications[0].value)
      }
      return null
    })
  }

  React.useEffect(() => {
    defaultSelect(specificationsData)
    const { nterminalMod, cterminalMod } =
      state.sessionData[state.currentOligoIndex]
    sessionData[currentOligoIndex].productType = productDetails.productType
    sessionData[state.currentOligoIndex].amount = amount
    sessionData[state.currentOligoIndex].purityLevel = purityLevel
    sessionData[state.currentOligoIndex].quantitation = quantitation
    sessionData[state.currentOligoIndex].format = format
    state.errorData.amount = amount
    state.errorData.purityLevel = purityLevel
    state.errorData.quantitation = quantitation
    state.errorData.format = format
    if (nterminalMod) {
      state.errorData.nterminalMod = nterminalMod
    }
    if (cterminalMod) {
      state.errorData.cterminalMod = cterminalMod
    }
    // TODO: need a test before we refactor these dependencies
  }, [state.currentOligoIndex, sessionData[state.currentOligoIndex].sequence])

  const renderSpecifications = () => {
    const specificationList: any[] = []
    specificationsData.specifications.forEach((specification) => {
      specificationList.push(
        <Grid item sm={3}>
          <div className={classes.label}>
            {messages[specification.categoryDisplayName]?.defaultMessage ||
              specification.categoryDisplayName}
          </div>
          <div className={classes.subLabel}>
            {specification.specificationModifications[0].name}
          </div>
        </Grid>
      )
    })
    return specificationList
  }

  return (
    <div className={classes.contentWrapper}>
      <Grid container>
        <Grid item sm={6}>
          <h4 className={classes.subHead}>
            <FormattedMessage {...messages.CONF_SPECIFICATIONS} />
          </h4>
        </Grid>
      </Grid>

      <Grid
        container
        direction="row"
        alignItems="center"
        justify="center"
        className={classes.gridItem}
      >
        {renderSpecifications()}
      </Grid>
    </div>
  )
}

export default AquaSpecifications
